import { FaFile } from 'react-icons/fa6';
import { ID } from '../../components/ID';
import { PeekLink } from '../../components/PeekLink';

/** Compact document link for the amber review-warning lines on the project view. */
export function WarningDocumentLink({ documentId }: { documentId: string }) {
  return (
    <PeekLink type="document" id={documentId} className="inline-flex items-center gap-1">
      <FaFile className="size-3.5" />
      <ID id={documentId} />
    </PeekLink>
  );
}
